import * as React from 'react';

import { DelightedSurveyFeedbackProps, useDelightedSurvey } from './hooks/useDelightedSurvey';

export const DelightedSurveyFeedback = ({ clientId, language }: Omit<DelightedSurveyFeedbackProps, 'surveyType'>) => {
	useDelightedSurvey({ clientId, language });

	return <></>;
};
